module.exports = __webpack_public_path__ + "static/media/popup.f6154d96.png";